/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-classes-per-file */
import React, { Component } from "react";
import { groupBy } from "lodash";
import classNames from "classnames";
import { Icon } from "@alifd/next";
import "./index.module.scss";

const SUPPORT_TYPES = ["error", "warn", "info"];
const DEFAULT_TYPE = "error";

const convertMsg = source => {
  const result = groupBy(source, "type");
  if (!result[DEFAULT_TYPE]) {
    result[DEFAULT_TYPE] = [];
  }
  Object.keys(result).forEach(key => {
    if (SUPPORT_TYPES.indexOf(key) === -1) {
      result[DEFAULT_TYPE].push(...result[key]);
    }
  });
  return result;
};

// 以提示信息 第一个非空 title
const getTitle = source => {
  const titleItem = source && source.find(item => !!item.title);
  return titleItem ? titleItem.title : "";
};

const renderIcon = type => {
  switch (type) {
    case "error":
      return (
        <Icon type="error" style={{ color: "#FF4242", marginRight: "10px" }} />
      );
    case "warn":
      return (
        <Icon
          type="warning"
          style={{ color: "#FF9366", marginRight: "10px" }}
        />
      );
    case "info":
      return (
        <Icon type="prompt" style={{ color: "#3C99D8", marginRight: "10px" }} />
      );
    default:
      return null;
  }
};

const renderMsg = (type, msgs) => {
  if (!msgs || msgs.length === 0) {
    return null;
  }
  const title = getTitle(msgs);
  return (
    <section className={classNames("section", `${type}`)}>
      <h2>
        {renderIcon(type)}
        {title}
      </h2>
      <ul>
        {msgs.map((item, index) => (
          <li key={`msg-${index}`}>{item.message}</li>
        ))}
      </ul>
    </section>
  );
};

const renderDefault = (message, height) => {
  const msgObj = convertMsg(message);
  return (
    <article className="content" style={{ height }}>
      {renderMsg("error", msgObj.error)}
      {renderMsg("warn", msgObj.warn)}
      {renderMsg("info", msgObj.info)}
    </article>
  );
};

export default class GlobalMessage extends Component {
  render() {
    const { message } = this.props;
    return <div className="gov-glboal-message">{renderDefault(message)}</div>;
  }
}

const initHeight = 90;

export class MobileGlobalMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: initHeight,
      collapsed: true,
      backgroundColor: "rgb(255, 255, 255)"
    };
  }

  componentWillUnmount() {
    document
      .getElementById("message-body")
      .removeEventListener("touchmove", this.onTouchmove);
  }

  onTouchmove = e => {
    e.preventDefault();
  };

  onCollapse = () => {
    const rootEl = document.getElementById("message-body");
    this.setState(({ collapsed }) => {
      const nextCollapsedState = !collapsed;
      if (!nextCollapsedState) {
        rootEl.addEventListener("touchmove", this.onTouchmove, {
          passive: false
        });
      } else {
        rootEl.removeEventListener("touchmove", this.onTouchmove);
      }
      return {
        height: nextCollapsedState ? initHeight : "70vh",
        collapsed: nextCollapsedState,
        backgroundColor: nextCollapsedState
          ? "rgb(255, 255, 255)"
          : "rgba(255, 255, 255, 0.9)"
      };
    });
  };

  render() {
    const { message } = this.props;
    const { height, collapsed, backgroundColor } = this.state;
    const shouldCollapse = message && message.length > 3;
    return (
      <div
        id="message-body"
        className="gov-mobile-glboal-message"
        style={{ backgroundColor }}
      >
        {renderDefault(message, height)}
        {shouldCollapse ? (
          <div className="bar" onClick={this.onCollapse}>
            <a>{collapsed ? "显示全部" : "收起"}</a>
            {collapsed ? <Icon type="arrow-down" /> : <Icon type="arrow-up" />}
          </div>
        ) : null}
      </div>
    );
  }
}
